import allUrls from '@/utils/config'

export const ConsignLinks = [
  {
    name: 'shippingGuide',
    il8nName: 'navs.shippingGuide',
    cname: '寄件指南',
    path: '/consign',
    params: { query: { isProduct: 'guide' } },
  },
  {
    name: 'freightAging',
    il8nName: 'serviceSupport.querySupport.freight_aging',
    cname: '查运费时效',
    path: '/support/querySupport/freight_aging',
  },
  {
    name: 'postingStd',
    il8nName: 'navs.posting_std',
    cname: '查收寄标准',
    path: '/support/querySupport/receiving_standard',
  },
  {
    name: 'serviceDept',
    il8nName: 'serviceSupport.querySupport.service_dept',
    cname: '查询服务网点',
    path: '/support/querySupport/dept',
  },
  {
    name: 'corporateAccount',
    il8nName: 'navs.corporateAccount',
    cname: '开设企业账号',
    path: '/consign',
    params: { query: { isProduct: 'corporate' } },
  },
]

export const ConsignQuickActions = {
  iuopLink: allUrls.iuoploginUrl,
  iuopLinkIl8n: 'navs.iuopLogin',
  wxMiniAppLink: allUrls.ciosActivity,
}

export default {
  path: '/consign',
  cname: '马上寄件',
  name: 'consign',
  il8nName: 'navs.shipNow',
  children: ConsignLinks,
}
